import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";
import {useStores} from "../../../stores";
import {KoiFacade} from "../../../components/koi-facade/KoiFacade";
import './KoiSupplierHierarchy.scss';
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Typography from "@mui/material/Typography";
import Stepper from "@mui/material/Stepper";
import {Button, Grid} from "@mui/material";
import type {DataColumn} from "../../../components/data-table/DataTable";
import {DataTable} from "../../../components/data-table/DataTable";
import {environment} from "../../../env";
import {RESULT_DATA} from "./demo/DemoData";
import {useLocation, useParams} from "react-router";
import {generateHomePath} from "../../../routing/routing.utils";

const HARDCODED_AI_INTEGRATION = {
    SUPPLIER_HIERARCHY_FINDER_TIMEOUT_MS: 6000,
}
const FAKE_AI_INTEGRATION: boolean =
    // false
    true
;


type KeyValues = {
    total_suppliers: number;
    parent_suppliers: number;
    child_suppliers: number;
    stand_alone: number;
}

const RESULT_COLUMNS: DataColumn[] = [
    {
        dataIndex: 'supplier_name',
        headerText: 'Supplier name',
        ltr: true,
    },
    {
        dataIndex: 'parent_supplier',
        headerText: 'Identified parent supplier',
        ltr: true,
    },
];

function pseudoHardcodeFraction(liveValue, referenceTotal, referenceTarget) {
    // TODO: Remove hardcoded
    const fraction = referenceTarget / referenceTotal;
    const pseudo = liveValue * fraction;
    return Math.round(pseudo);
}

// const PROCESSING_DURATION_HACK_MINUTES = 7;

export const KoiSupplierHierarchy: React.FC = observer(() => {
    // const theme = useTheme();

    const {rootAppStore, bagStore} = useStores();
    const params = useParams();
    const location = useLocation();
    const bagId = bagStore.bagId;

    const [activeStep, setActiveStep] = React.useState<number>(0);

    const [keyValues, setKeyValues] = React.useState<KeyValues | undefined>(undefined);
    // useEffect(() => {
    //     // TODO: Replace stats and keyValues with bagStore.kpi.common
    //     const sub = forkJoin([
    //         from(jobStore.getJobStats()),
    //         // from(jobStore.getJobKoiCumSuppliersL1Summary()),
    //         // from(jobStore.getJobKoiCumSuppliers(1)),
    //     ])
    //         .pipe(map(([
    //                        stats,
    //                        // l1Resp,
    //                        // topResp
    //                    ]) => ({
    //             // total_suppliers: totalSuppliers,
    //             total_suppliers: stats.data.n_suppliers,
    //             parent_suppliers: pseudoHardcodeFraction(stats.data.n_suppliers, 127, 8),
    //             child_suppliers: pseudoHardcodeFraction(stats.data.n_suppliers, 127, 26),
    //             stand_alone: pseudoHardcodeFraction(stats.data.n_suppliers, 127, 101),
    //         })))
    //         .subscribe(keyValues => {
    //             setKeyValues(keyValues);
    //         });
    //     return () => sub.unsubscribe();
    // }, [jobStore])

    useEffect(() => {
        if (activeStep === 1) {
            setTimeout(() => {
                setActiveStep(2);
            }, HARDCODED_AI_INTEGRATION.SUPPLIER_HIERARCHY_FINDER_TIMEOUT_MS);
        }
    }, [activeStep]);

    const step0 = <div className="page-item step-0">

        <div style={{minHeight: '13em'}}>
            <Grid container justifyContent="space-evenly">
                <Grid
                    container
                    justifyContent="space-around"
                    style={{alignContent: 'space-around'}}
                    alignItems="center"
                    size={5}>
                    <Grid
                        className="key-value-container text-center font-bigger"
                        container
                        spacing={4}
                        size={10}>
                        {/* Row 1 */}
                        <Grid container style={{justifyContent: "space-between"}}>
                            <Grid>
                                <Typography variant="caption">
                                    Total
                                    <br/>suppliers
                                </Typography>
                                <Typography variant="h5" className="font-weight-bold key-value">
                                    {keyValues
                                        ? `${keyValues.total_suppliers}`
                                        : <>&nbsp;</>}
                                </Typography>
                            </Grid>
                            <Grid>
                                <Typography variant="caption">
                                    Parent
                                    <br/>suppliers
                                </Typography>
                                <Typography variant="h5" className="font-weight-bold key-value">
                                    {keyValues
                                        ? `?`
                                        : <>&nbsp;</>}
                                </Typography>
                            </Grid>
                            <Grid>
                                <Typography variant="caption">
                                    Child
                                    <br/>suppliers
                                </Typography>
                                <Typography variant="h5" className="font-weight-bold key-value">
                                    {keyValues
                                        ? `?`
                                        : <>&nbsp;</>}
                                </Typography>
                            </Grid>
                            <Grid>
                                <Typography variant="caption">
                                    Standalone
                                    <br/>suppliers
                                </Typography>
                                <Typography variant="h5" className="font-weight-bold key-value">
                                    {keyValues
                                        ? `?`
                                        : <>&nbsp;</>}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div>

        <Grid container justifyContent="space-evenly">
            <Grid className="text-center" size={3}>
                <Button variant="contained" color="primary" onClick={() => setActiveStep(1)}>
                    Find supplier hierarchy
                </Button>
            </Grid>
        </Grid>
    </div>;

    const step1 = <div className="page-item step-1">
        {/*/!* Header *!/*/}
        {/*<Grid container justifyContent="space-evenly">*/}
        {/*    <Grid size={5}>*/}
        {/*        <Typography variant="h6" align="center">Determining the parent and child suppliers ...</Typography>*/}
        {/*    </Grid>*/}
        {/*    <Grid size={4}>*/}
        {/*    </Grid>*/}
        {/*</Grid>*/}

        <Grid container justifyContent="space-evenly">
            <Grid
                container
                justifyContent="space-around"
                style={{alignContent: 'space-around'}}
                alignItems="center"
                size={4}>
                <Grid
                    container
                    direction="column"
                    justifyContent="space-around"
                    style={{alignContent: 'space-around'}}
                    alignItems="center"
                    className="text-center">
                    <Grid className="font-bigger">
                        <Typography variant="caption">
                            Estimated completion time:
                            {/*<br/>suppliers*/}
                        </Typography>
                        <Typography variant="h5" className="font-weight-bold key-value">
                            {/*{showEstimation(PROCESSING_DURATION_HACK_MINUTES)}*/}
                            in a few seconds
                        </Typography>
                    </Grid>
                    <Grid>
                        {/*Hidden button*/}
                        <div style={{width: '50px', height: '50px'}} onClick={() => setActiveStep(2)}/>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    </div>;

    const step2 = <div className="page-item step-2">
        <div style={{minHeight: '11em'}}>
            <Grid container justifyContent="space-evenly">
                <Grid
                    container
                    justifyContent="space-around"
                    style={{alignContent: 'space-around'}}
                    alignItems="center"
                    size={7}>
                    <Grid
                        className="key-value-container text-center font-bigger"
                        container
                        spacing={4}
                        size={11}>
                        {/* Row 1 */}
                        <Grid container style={{justifyContent: "space-between"}}>
                            <Grid>
                                <Typography variant="caption">
                                    Total
                                    <br/>suppliers
                                </Typography>
                                <Typography variant="h5" className="font-weight-bold key-value">
                                    {keyValues
                                        ? `${keyValues.total_suppliers}`
                                        : <>&nbsp;</>}
                                </Typography>
                            </Grid>
                            <Grid>
                                <Typography variant="caption">
                                    Parent
                                    <br/>suppliers
                                </Typography>
                                <Typography variant="h5" className="font-weight-bold key-value">
                                    {keyValues
                                        ? `${keyValues.parent_suppliers}`
                                        : <>&nbsp;</>}
                                </Typography>
                            </Grid>
                            <Grid>
                                <Typography variant="caption">
                                    Child
                                    <br/>suppliers
                                </Typography>
                                <Typography variant="h5" className="font-weight-bold key-value">
                                    {keyValues
                                        ? `${keyValues.child_suppliers}`
                                        : <>&nbsp;</>}
                                </Typography>
                            </Grid>
                            <Grid>
                                <Typography variant="caption">
                                    Standalone
                                    <br/>suppliers
                                </Typography>
                                <Typography variant="h5" className="font-weight-bold key-value">
                                    {keyValues
                                        ? `${keyValues.stand_alone}`
                                        : <>&nbsp;</>}
                                </Typography>
                            </Grid>

                            <Grid>
                                <a className="button" href={environment.demoFiles.supplierHierarchy.url}>
                                    <Button variant="contained" color="primary" style={{margin: '2em'}}>
                                        Download results
                                    </Button>
                                </a>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div>

        <Grid container justifyContent="space-evenly">
            {/*<Grid size={8}>*/}
            {/*    <Typography variant="h6">Result</Typography>*/}
            {/*</Grid>*/}
            <Grid style={{minHeight: '10em'}} size={7}>
                <DataTable
                    className="supplier-hierarchy-table alt-rows"
                    tableColumns={RESULT_COLUMNS}
                    data={RESULT_DATA.map(([supplier_name, parent_supplier]) =>
                        ({supplier_name, parent_supplier})
                    )}
                    emptyCaption="Loading"
                    pageSize={12}
                />
            </Grid>
        </Grid>


    </div>;


    return (
        <KoiFacade
            title="Supplier Hierarchy"
            intro={<></>}
            back={generateHomePath(location, {id: String(bagId)}, rootAppStore.app)}
            className="koi-sh-page">

            <Grid container justifyContent="space-evenly">
                <Grid size={8}>
                    <Stepper orientation={"horizontal"} activeStep={activeStep}>
                        <Step>
                            <StepLabel>Capture all supplier profiles</StepLabel>
                        </Step>
                        <Step>
                            <StepLabel>Determine the parent and child suppliers</StepLabel>
                        </Step>
                        <Step>
                            <StepLabel>Download results</StepLabel>
                        </Step>
                    </Stepper>
                </Grid>
            </Grid>

            {activeStep === 0 && step0}
            {activeStep === 1 && step1}
            {activeStep === 2 && step2}

        </KoiFacade>
    );
});
